import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { RocketIcon } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export default function LaunchSection() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (user) {
      navigate('/create', { replace: true });
    } else {
      navigate('/register', { replace: true });
    }
  };

  return (
    <div className="bg-gradient-to-r from-primary-500 to-primary-600">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="space-y-4"
        >
          <RocketIcon className="h-12 w-12 text-primary-100" />
          <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
            <span className="block">Ready to dive in?</span>
            <span className="block text-primary-100">Join our community today.</span>
          </h2>
          <p className="text-lg text-primary-50 max-w-lg">
            Be among the first to experience SnapVote and help shape the future of collective decision-making.
          </p>
        </motion.div>
      </div>
    </div>
  );
}